import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { IContractType } from './IContractType';

@Injectable({
    providedIn: 'root'
})
export class ContractTypeLookupService {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    private contracttypeurl = `${environment.apiLocation}/ContractType`;
    public getContractTypes(): Observable<Array<IContractType>> {
        return this.http
            .get<Array<IContractType>>(this.contracttypeurl)
            .pipe(res => {
                this.log.verbose({
                    type: 'CustomerJobComponent:getContractTypes:reponse',
                    res
                });
                return res;
            });
    }
}
